module.exports = __webpack_public_path__ + "static/viralimg-ecb787a8588ff832ac83960a28fc6233.jpg";